<template>
  <div>
    <validation-observer ref="createPaymentJournalRef" novalidate tag="form">
      <custom-callout
        border-color="green"
        class="mb-4 custom-callout-invoice"
        :has-toggle="false"
      >
        <div class="row">
          <div class="col-md-12">
            <icon-view
              icon="fa fa-file-plus"
              icon-background="#fff"
              icon-color="#2DB782"
              icon-size="16px"
              title="Crear Nuevo Jornal de Pago"
            />
          </div>
        </div>
        <div class="row ml-2 mt-3">
          <div class="col-md-3 col-sm-12 pb-2">
            <div class="color-secondary-6 font-weight-normal font-14 mb-2">
              Año Académico:
            </div>
            <validation-provider
              v-slot="{ errors }"
              mode="eager"
              rules="required"
            >
              <drop-down
                id="ddlAcademicYear"
                v-model="model.academicYear"
                :clearable="false"
                custom-error-msg="Campo requerido."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="academicYears"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-md-9 text-right mt-3 pr-5">
            <action-button
              id="btnCancel"
              i="fas fa-times-circle"
              variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
              @click="onCancel()"
            >
              Cancelar
            </action-button>
            <action-button
              id="btnContinue"
              i="fas fa-arrow-circle-right"
              variant="success pl-4 pr-4"
              @click="onContinue()"
            >
              Continuar
            </action-button>
          </div>
        </div>
      </custom-callout>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomCallout from 'custom-callout';
import IconView from 'icon-view';
import DropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import alertMixin from 'utils/mixins/alert.mixin.js';

export default {
  name: 'CreateJournal',
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomCallout,
    IconView,
    DropDown,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    academicYears: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      model: {
        academicYear: null,
      },
    };
  },
  methods: {
    onCancel() {
      this.$emit('on-cancel');
    },
    async onContinue() {
      const isValid = await this.$refs.createPaymentJournalRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor de documentar los campos requeridos para continuar con la acción.',
          'error'
        );
        return;
      }

      this.$emit('on-continue', { ...this.model });
    },
  },
};
</script>

<style></style>
